<template>
  <div class="row no-gutters align-items-center">
    <div class="col light-background rounded-left">
      <select class="pl-2 right-chevron" v-model="filterProps.dateRangeType">
        <option value="creation">{{
          $t('reports.customers-reports.creation-date-range')
        }}</option>
        <option value="departure">{{
          $t('reports.customers-reports.departure-date-range')
        }}</option>
      </select>
    </div>
    <div class="col light-background rounded-right">
      <core-date-range-calendar
        :key="resetFormKey"
        :start.sync="filterProps.createdFrom"
        :end.sync="filterProps.createdUntil"
        :locale="'en-GB'"
        :placement="'top'"
      ></core-date-range-calendar>
    </div>
    <div class="col">
      <input
        class="form-control search-input filter-border-bottom"
        name="reservation-person-email"
        v-model="filterProps.email"
        type="text"
        :placeholder="$t('reports.customers-reports.customer-email')"
      />
    </div>
    <div class="col-1 text-right">
      <button @click="resetForm" class="btn btn-sm btn-primary">
        {{ $t('reports.customers-reports.reset-form') }}
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import ReservationPerson from '@/services/hatsApi/ReservationPerson'
import Geo from '@/services/hatsApi/Geo'

export default {
  data () {
    return {
      resetFormKey: false,
      filterProps: {
        dateRangeType: 'creation',
        email: '',
        createdFrom: this.dateFrom,
        createdUntil: this.dateUntil
      },
      countries: [],
      users: []
    }
  },
  props: {
    dateFrom: {
      default: moment().format('YYYY-MM-DD'),
      type: String,
      required: false
    },
    dateUntil: {
      default: moment().format('YYYY-MM-DD'),
      type: String,
      required: false
    }
  },
  watch: {
    filterProps: {
      handler () {
        this.debouncedSearch()
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    ...mapGetters(['serviceCategories'])
  },
  async created () {
    Geo.getCountries().then((response) => {
      this.countries = response.data.data
    })
    this.debouncedSearch = this.$_.debounce(this.prepareAndEmitFilters, 500)
    this.getServiceCategories()
    let persons = await ReservationPerson.getReservationUsers()
    if (persons.data.success) {
      this.users = persons.data.data
    }
  },
  methods: {
    getTitle () {
      return 'name_' + this.$i18n.locale.toUpperCase()
    },
    async getServiceCategories () {
      await this.$store.dispatch('getServiceCategories')
    },
    resetForm () {
      this.resetFormKey = !this.resetFormKey
      this.filterProps = {
        dateRangeType: 'creation',
        serviceCode: '',
        serviceCategoryId: '',
        reference: '',
        createdFrom: this.dateFrom,
        createdUntil: this.dateUntil
      }
    },
    prepareAndEmitFilters () {
      let filters = []
      const copiedFilters = { ...this.filterProps }
      if (copiedFilters.dateRangeType === 'departure') {
        copiedFilters.dateFrom = copiedFilters.createdFrom
        copiedFilters.dateUntil = copiedFilters.createdUntil
        delete copiedFilters.createdFrom
        delete copiedFilters.createdUntil
      }
      if (copiedFilters.country && copiedFilters.country.code) {
        copiedFilters.country = copiedFilters.country.code
      }
      Object.keys(copiedFilters).forEach(filterProp => {
        if (filterProp !== 'dateRangeType' && copiedFilters[filterProp]) {
          let f = {
            property: `${filterProp}`,
            value: `${copiedFilters[filterProp]}`
          }
          filters.push(f)
        }
      })
      this.$emit('filtersUpdated', filters)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .vc-shadow {
  border: none;
  background-color: #f7fafc;
  box-shadow: none;
  color: #008cdd;
  font-family: 'Open Sans Semibold';
  font-size: 14px;
}

.light-background {
  .right-chevron {
    line-height: 35px;
  }
  background-color: #f7fafc;
}

.category-selection, .category-selection input.vs__search {
  font-family: 'Open Sans Italic';
  font-size: 12px;
  border-bottom: 1px solid #dddddd;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/CustomersReports.vue